/*金融政策*/
import FinancialPolicy from "./FinancialPolicy";

export default FinancialPolicy;
